var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 250",
    style: {
      enableBackground: "new 0 0 250 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{fill:#F0F0F0;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#E2E2E2;}\n\t.st4{fill:#D4D4D4;}\n\t.st5{fill:#D5D5D5;}\n\t.st6{fill:#CEC3D8;}\n\t.st7{fill:#E2D9EB;}\n\t.st8{fill:#010101;}\n\t.st9{fill:#CCC7DA;}\n\t.st10{fill:none;stroke:#9B86CE;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#9B86CE;stroke-width:5;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible"
    },
    width: 740,
    height: 1097,
    xlinkHref: "C6FD1F67.jpg",
    transform: "matrix(0.397 0 0 0.397 -21.8991 -23.6699)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 119.8,
    cy: 126.6,
    r: 86.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M156.5,176.7H85.7c-5.1,0-9.2-4.1-9.2-9.2V74.9c0-5.1,4.1-9.2,9.2-9.2h70.8c5.1,0,9.2,4.1,9.2,9.2v92.6 C165.7,172.6,161.6,176.7,156.5,176.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M233.1,83.5H179c-3.7,0-6.8-3-6.8-6.8V58.4c0-3.7,3-6.8,6.8-6.8h54.1c3.7,0,6.8,3,6.8,6.8v18.3 C239.9,80.5,236.8,83.5,233.1,83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M152.6,106.4H87.7c-1.7,0-3.1-1.4-3.1-3.1v-0.6c0-1.7,1.4-3.1,3.1-3.1h64.9c1.7,0,3.1,1.4,3.1,3.1v0.6 C155.7,105,154.3,106.4,152.6,106.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M152.6,126.6H87.7c-1.7,0-3.1-1.4-3.1-3.1v-0.6c0-1.7,1.4-3.1,3.1-3.1h64.9c1.7,0,3.1,1.4,3.1,3.1v0.6 C155.7,125.2,154.3,126.6,152.6,126.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M152.2,146.8H87.3c-1.7,0-3.1-1.4-3.1-3.1v-0.6c0-1.7,1.4-3.1,3.1-3.1h64.9c1.7,0,3.1,1.4,3.1,3.1v0.6 C155.3,145.5,153.9,146.8,152.2,146.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M152.6,166.1H87.7c-1.7,0-3.1-1.4-3.1-3.1v-0.6c0-1.7,1.4-3.1,3.1-3.1h64.9c1.7,0,3.1,1.4,3.1,3.1v0.6 C155.7,164.7,154.3,166.1,152.6,166.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "167.9,171.5 198.3,201 209.2,189.2 179.2,160.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M209.2,189.2c0,0,6.7,4,3.3,11.8c-1,1.3-6.7,7.3-14.3,0C202.5,196.5,209.2,189.2,209.2,189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M145.3,129.7l9.4-9.4c0,0,4-3.8,7.6,1.3c0.4,1.3,1.1,3-1.5,6.3c-3.3,3.1-9,8.7-9,8.7l10,9.9 c0,0,1.9,2.8-0.2,5.5c-0.6,0.9-3.2,3.7-7.2,0.7c-2.6-2.6-9.7-9.5-9.7-9.5l-9.1,10.1c0,0-3,2.5-7-0.5c-0.8-1-2.6-3.4,0-6.7 c1.3-1.2,9.8-9.4,9.8-9.4l-10-9.6c0,0-2.8-2.7,0-6.7c1-1.1,3.9-3.3,8.1,0.9S145.3,129.7,145.3,129.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M116.6,87H88.4c-1.8,0-3.2-1.4-3.2-3.2v-0.6c0-1.8,1.4-3.2,3.2-3.2h28.2c1.8,0,3.2,1.4,3.2,3.2v0.6 C119.8,85.6,118.4,87,116.6,87z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 182.3,
    cy: 67.8,
    r: 4.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 216.5,
    cy: 151.7,
    r: 4.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M211.1,72h-14.8c-2.1,0-3.8-1.7-3.8-3.8v-0.8c0-2.1,1.7-3.8,3.8-3.8h14.8c2.1,0,3.8,1.7,3.8,3.8v0.8 C214.8,70.3,213.1,72,211.1,72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M18.2,115.6c0,0,28.4-8.6,34.2-25.8c0.5-1,3.3-10.3-6.4-13c-2.6-0.3-10.4-1.8-12.3,5.3c0,1.7,3.1,13,21.1,3.9 c3.3-2.3,17.9-15.2,21.9-22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M54.2,181.8c0,0,5.4,1.3,6.4-8.6c0.1,4.8-0.1,10.1,8,9.2c-4.5,1.8-5.8,2.2-8.3,7.7 C59.3,186.4,57.4,182.4,54.2,181.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 144.7,
    cy: 136.8,
    r: 41.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.074ca48454003442c789d0e1b7f4c13a.svg";
export { ForwardRef as ReactComponent };